import * as React from 'react';
import Swal from 'sweetalert2';
import { jaxa } from '../../App';
import { useTheme } from '@emotion/react';
import { Close as CloseIcon } from '@mui/icons-material';
import { Button, Dialog, List,  AppBar, Toolbar, IconButton, Typography, Slide, OutlinedInput, FormControl, ListItem, FormLabel, Box, Backdrop, CircularProgress, useMediaQuery, Checkbox, FormControlLabel } from '@mui/material';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const CreateClient = ({open, handleClose}) => {

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const [loading, setLoading] = React.useState(false);

    const handleSubmit = async(e) => {
        e.preventDefault();
        const data = new FormData(e.currentTarget);
        const params = {
            name: data.get('cname'), 
            status: data.get('status'), 
            clientType: data.get('ctype'), 
            email: data.get('email'), 
            mob1: data.get('ph1'), 
            mob2: data.get('ph2'), 
            comments: data.get('comments'), 
            clientCode: data.get('ccode'), 
            amc: data.get('amc') ? 1 : 0, 
        };
        setLoading(true);
        await jaxa.post('/create-client', params).then((e) => {
            Swal.fire({ title: 'Client was created' });
        }).catch((e) => {
            Swal.fire({ title: 'Error creating client' });
            console.log(`Error: ${e}`);
        });
        setLoading(false);
        handleClose();
    };

    const loader = React.useMemo(() => (
        <Backdrop open>
            <CircularProgress />
        </Backdrop>
    ), []);

    return (

        <Dialog fullScreen={fullScreen} open={open} onClose={handleClose} TransitionComponent={Transition}>
            <AppBar sx={{ position: 'relative' }}>
                <Toolbar>
                    <IconButton
                    edge="start"
                    color="inherit"
                    onClick={handleClose}
                    aria-label="close">
                    <CloseIcon />
                    </IconButton>
                    <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">Create Client</Typography>
                </Toolbar>
            </AppBar>
            <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                <List>
                    <ListItem  sx={{ justifyContent: 'space-between', flexDirection: { xs: 'column', md: 'row' } }}>
                        <FormControl>
                            <FormLabel htmlFor="cname">Client Name</FormLabel>
                            <OutlinedInput  required margin="dense" id="cname" name="cname" label="Client Name" placeholder="Client Name" type="text" fullWidth inputProps={{ maxLength: 50 }}/>
                        </FormControl>
                        <FormControl>
                            <FormLabel htmlFor="ccode">Client Code</FormLabel>
                            <OutlinedInput  required margin="dense" id="ccode" name="ccode" label="Client Code" placeholder="Client Code" type="text" fullWidth inputProps={{ maxLength: 20 }}/>
                        </FormControl>
                    </ListItem>
                    <ListItem  sx={{ justifyContent: 'space-between', flexDirection: { xs: 'column', md: 'row' } }}>
                        <FormControl>
                            <FormLabel htmlFor="status">Status</FormLabel>
                            <OutlinedInput  required margin="dense" id="status" name="status" label="Status" placeholder="Status" type="text" fullWidth inputProps={{ maxLength: 30 }}/>
                        </FormControl>
                        <FormControl>
                            <FormLabel htmlFor="ctype">Client Type</FormLabel>
                            <OutlinedInput  required margin="dense" id="ctype" name="ctype" label="Client Type" placeholder="Client Type" type="text" fullWidth inputProps={{ maxLength: 30 }}/>
                        </FormControl>
                    </ListItem>
                    <ListItem  sx={{ flexDirection: { xs: 'column', md: 'row' } }}>
                        <FormControl>
                            <FormLabel htmlFor="email">Email</FormLabel>
                            <OutlinedInput  margin="dense" id="email" name="email" label="Email" placeholder="Email" type="email" fullWidth inputProps={{ maxLength: 50 }}/>
                        </FormControl>
                        <FormControlLabel control={<Checkbox id='amc' name='amc' size='large'/>} label="AMC" sx={{ ml: { xs: 0, md: 10 }, mt: 3 }}/>
                    </ListItem>
                    <ListItem  sx={{ justifyContent: 'space-between', flexDirection: { xs: 'column', md: 'row' } }}>
                        <FormControl>
                            <FormLabel htmlFor="ph1">Phone Number 1</FormLabel>
                            <OutlinedInput  required margin="dense" id="ph1" name="ph1" label="Phone Number 1" placeholder="Phone Number 1" type="tel" fullWidth inputProps={{ maxLength: 15 }}/>
                        </FormControl>
                        <FormControl>
                            <FormLabel htmlFor="ph2">Phone Number 2</FormLabel>
                            <OutlinedInput  margin="dense" id="ph2" name="ph2" label="Phone Number 2" placeholder="Phone Number 2" type="tel" fullWidth inputProps={{ maxLength: 15 }}/>
                        </FormControl>
                    </ListItem>
                    <ListItem>
                        <FormControl fullWidth>
                            <FormLabel htmlFor="comments">Comments</FormLabel>
                            <OutlinedInput multiline  margin="dense" id="comments" name="comments" label="Comments" placeholder="Comments" type="text" fullWidth inputProps={{ maxLength: 500 }}/>
                        </FormControl>
                    </ListItem>
                    <ListItem>
                        <Button disabled={loading} type='submit' color="inherit" variant='outlined' fullWidth sx={{ m: 2 }}>CREATE</Button>
                    </ListItem>
                </List>
            </Box>
            {loading ? loader : null}
        </Dialog>

    );

};

export default React.memo(CreateClient);